import { ApiError } from '@/lib/api';
import { describeError } from '@/lib/auth';

const READABLE_VALIDATION_PATHS = ['qcOverrideReason', 'overrideReason'];

export function hasDetailPath(error: unknown, path: string): boolean {
  return error instanceof ApiError && error.details.some((detail) => detail.path === path);
}

export function isConflict(error: unknown): error is ApiError {
  return error instanceof ApiError && error.status === 409;
}

export function messageMentions(error: unknown, text: string): boolean {
  return error instanceof ApiError && error.message.toLowerCase().includes(text.toLowerCase());
}

export function apiMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 409) return error.message;
    if (error.status === 422 && READABLE_VALIDATION_PATHS.some((path) => hasDetailPath(error, path))) return error.message;
  }
  return describeError(error);
}
